export const PropertyClass = Object.freeze({
  LUXURY: 'LUXURY',
  ELEGANT: 'ELEGANT',
  STANDARD: 'STANDARD',
  ECONOMIC: 'ECONOMIC',
});

export type PropertyClassType = typeof PropertyClass[keyof typeof PropertyClass];
